exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "mat-table {\n  width: 100%; }\n\nmat-paginator {\n  margin-top: 16px; }\n\n.text-success {\n  color: #2e7d32; }\n\n.text-danger {\n  color: #c62828; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/ProductsModule/ProductTransfersListComponent/product-transfers-list.component.scss
// module id = ../../../../../src/ProductsModule/ProductTransfersListComponent/product-transfers-list.component.scss
// module chunks = main